import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormControlServiceService {
  toFormGroup(fields: any ) {
    const group: any = {};

    fields.forEach((field:any) => {
      group[field.name] = field.required ?
       new FormControl({value:field.value, disabled:field.disabled} , Validators.required): 
       new FormControl({value:field.value, disabled:field.disabled} );
    });
    return new FormGroup(group);
  }

  isValid(form:FormGroup){
    let isValid = true;
    for(let key of Object.keys(form.controls)){
      if(!form.controls[key].valid && !form.controls[key].disabled){
        isValid= false;
      }
    }
    return isValid;  
  }

  getMsg(controls:Object, form:FormGroup){
    let msg="";
    for(let key of Object.keys(controls)){
      if(!form.controls[key].valid && !form.controls[key].disabled){
        if(!key.includes("privacy.") && !key.includes("terms.") && !key.includes("Optin_.")){
          msg="text.menu.profile.fieldrequired";
          break;
        }else{
          msg="text.toast.optin_acceptance_warning";
          break;
        }
      }
    };
    return msg;
  }
}
